import React, {Component} from 'react';
import {Provider} from "react-redux";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import AppLayout from "./AppLayout";
import PersonView from './browse/person/PersonView'
import LoginPage from "./auth/LoginPage";
import PersonDetails from "./browse/person/PersonDetails";
import SiteView from "./browse/site/SiteView";
import CustomerView from "./browse/customer/CustomerView"
import SiteDetails from "./browse/site/SiteDetails";
import GlobalLovView from "./lovs/map/GlobalLovView";
import LovManageView from "./lovs/manage/LovManageView";
import SelectionView from "./browse/selection/SelectionView";
import importView from "./browse/import/statistics";
import SelectionDetails from "./browse/selection/SelectionDetails";
import importDetails from "./browse/import/importStatisticsDetails";
import LovResultTypes from "./lovs/result/lovResultTypes";
import LovResultDetails from "./lovs/result/LovResultDetail";
import {init} from "./reducers/auth";
import LogoutPage from "./auth/LogoutPage";
import SelectionOverview from "./selection/SelectionOverview";
import Selection from "./selection/Selection";


class App extends Component {
    
    constructor(props) {
        super(props);
        props.store.dispatch(init());
    }
    
    PrivateRoute = ({component: Component, ...rest}) => <Route {...rest} render={props =>
        this.props.store.getState().auth.loggedIn
            ? <Component {...props} />
            : <Redirect to={{pathname: '/login', from: props.location}}/>
    }/>;
    
    render() {
        const {PrivateRoute} = this;
        const {store} = this.props;
        
        return <Provider store={store}>
            <BrowserRouter>
                <Switch>
                    <Route path="/login" component={LoginPage}/>
                    <AppLayout>
                        <PrivateRoute path="/" component={PersonView} exact/>
                        <PrivateRoute path="/browse/person" component={PersonView}/>
                        <PrivateRoute path="/browse/site" component={SiteView}/>
                        <PrivateRoute path="/browse/selection" component={SelectionView}/>
                        <PrivateRoute path="/browse/selection/:id" component={SelectionDetails}/>
                        <PrivateRoute path="/browse/import" component={importView}/>
                        <PrivateRoute path="/import/:id" component={importDetails}/>
                        <PrivateRoute path="/person/:id" component={PersonDetails} exact/>
                        <PrivateRoute path="/person/mdm/:id" component={PersonDetails} exact/>
                        <PrivateRoute path="/site/:id" component={SiteDetails}/>
                        <PrivateRoute path="/lov/map" component={GlobalLovView}/>
                        <PrivateRoute path="/lov/manage" component={LovManageView}/>
                        <PrivateRoute path="/lov/lovResult" component={LovResultTypes}/>
                        <PrivateRoute path="/lovResult/:id" component={LovResultDetails}/>
                        <PrivateRoute path="/selection/builder" component={SelectionOverview}/>
                        <PrivateRoute path="/selection/builder/:id" component={Selection}/>
                        <PrivateRoute path="/browse/customer" component={CustomerView}/>
                        <PrivateRoute path="/logout" component={LogoutPage}/>
                    </AppLayout>
                </Switch>
            </BrowserRouter>
        </Provider>
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js